import React, { useState } from "react";
import { PairTrigger } from "./components/PairTrigger";
import { PairsModal } from "./components/PairsModal";
import { useFuturesPairs } from "./hooks/useFuturesPairs";
import { useFavoritePairs } from "../favorites/useFavoritePairs";
import "./FuturesPairs.sass";

/**
 * Current futures pair button + asset selection modal.
 */
export const FuturesPairs = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { currentPair, pairs, loading, search, onSearch, selectPair } =
    useFuturesPairs({ isOpen });
  const { isFavorite, toggleFavorite } = useFavoritePairs();

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  const onSelect = (pair) => {
    close();
    selectPair(pair);
  };

  return (
    <div
      className="futures-quote__current-pair-wrap"
      data-futures-guide="asset-selection-mobile"
    >
      <PairTrigger pair={currentPair} onClick={open} />

      <PairsModal
        isOpen={isOpen}
        pairs={pairs}
        loading={loading}
        search={search}
        onSearch={onSearch}
        onSelect={onSelect}
        onClose={close}
        isFavorite={isFavorite}
        onToggleFavorite={toggleFavorite}
      />
    </div>
  );
};
